function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenterActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.65,12.92H1v8.25A1.83,1.83,0,0,0,2.83,23h8.25V18.35A6.41,6.41,0,0,1,5.65,12.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.08,5.65V1H2.83A1.83,1.83,0,0,0,1,2.83v8.25H5.65A6.41,6.41,0,0,1,11.08,5.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.17,1H12.92V5.65a6.41,6.41,0,0,1,5.43,5.43H23V2.83A1.83,1.83,0,0,0,21.17,1Z",
    style: {
      fill: "#efeff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.92,18.35V23h8.25A1.83,1.83,0,0,0,23,21.17V12.92H18.35A6.41,6.41,0,0,1,12.92,18.35Z",
    style: {
      fill: "#efeff0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4.58,
    transform: "translate(-0.82 0.88) rotate(-4.07)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterActive);
export default __webpack_public_path__ + "static/media/center_active.86b1ffc95ea4648c358646a0939eb733.svg";
export { ForwardRef as ReactComponent };